import types from '@constants/action-types';
import { actionRequestFactory, actionResponseFactory } from '@factories';

export const setupTwoFactorAuthSuccess = auth =>
  actionResponseFactory(types.AUTH_TWO_FACTOR_AUTH_SUCCESS, { auth });
export const setupTwoFactorAuthFailure = error =>
  actionResponseFactory(types.AUTH_TWO_FACTOR_AUTH_FAILURE, { error });

/* Verify auth code */
export const verifyTwoFactorAuthCodeRequest = payload =>
  actionRequestFactory(types.AUTH_TWO_FACTOR_AUTH_CODE_REQUEST, payload);
export const verifyTwoFactorAuthCodeSuccess = auth =>
  actionResponseFactory(types.AUTH_TWO_FACTOR_AUTH_CODE_SUCCESS, { auth });
export const verifyTwoFactorAuthCodeFailure = error =>
  actionResponseFactory(types.AUTH_TWO_FACTOR_AUTH_CODE_FAILURE, { error });

/* Resend Auth Code */
export const resendTwoFactorAuthCodeRequest = payload =>
  actionRequestFactory(types.RESEND_TWO_FACTOR_AUTH_CODE_REQUEST, payload);
export const resendTwoFactorAuthCodeSuccess = auth =>
  actionResponseFactory(types.RESEND_TWO_FACTOR_AUTH_CODE_SUCCESS, { auth });
export const resendTwoFactorAuthCodeFailure = error =>
  actionResponseFactory(types.RESEND_TWO_FACTOR_AUTH_CODE_FAILURE, { error });
